import { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const platforms = [
  { value: 'amazon', label: 'أمازون' },
  { value: 'noon', label: 'نون' },
  { value: 'namshi', label: 'نمشي' },
  { value: 'aliexpress', label: 'علي إكسبريس' }
];

export default function RequestPage() {
  const [formData, setFormData] = useState({
    email: '',
    customer_name: '',
    platform: '',
    product_name: '',
    product_url: '',
    notes: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [requestIntroText, setRequestIntroText] = useState('');

  useEffect(() => {
    const fetchRequestIntro = async () => {
      try {
        const response = await axios.get(`${API}/settings/request-intro`);
        setRequestIntroText(response.data?.text || '');
      } catch (error) {
        setRequestIntroText('');
      }
    };
    fetchRequestIntro();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/requests`, {
        email: formData.email,
        customer_name: formData.customer_name,
        platform: formData.platform,
        product_name: formData.product_name,
        product_url: formData.product_url || undefined,
        notes: formData.notes || undefined
      });
      toast.success('تم إرسال الطلب بنجاح');
      setFormData({
        email: '',
        customer_name: '',
        platform: '',
        product_name: '',
        product_url: '',
        notes: ''
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'فشل إرسال الطلب');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50" dir="rtl">
      <Header />

      <main className="flex-grow">
        <div className="container mx-auto px-4 py-10">
          <div className="max-w-2xl mx-auto bg-white border border-gray-100 shadow-sm rounded-2xl p-6 md:p-8">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">طلب كوبون أو رابط منتج</h1>
            {requestIntroText.trim() ? (
              <p className="text-gray-600 mb-6 whitespace-pre-line">{requestIntroText}</p>
            ) : (
            <p className="text-gray-600 mb-6">املأ البيانات التالية وسنقوم بالرد عليك عبر البريد الإلكتروني.</p>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="request_name">الاسم</Label>
                <Input
                  id="request_name"
                  required
                  value={formData.customer_name}
                  onChange={(event) => setFormData({ ...formData, customer_name: event.target.value })}
                  placeholder="اسمك الكامل"
                  className="admin-input"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="request_email">البريد الإلكتروني</Label>
                <Input
                  id="request_email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={(event) => setFormData({ ...formData, email: event.target.value })}
                  placeholder="example@email.com"
                  className="admin-input"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="request_platform">المنصة</Label>
                <Select
                  value={formData.platform}
                  onValueChange={(value) => setFormData({ ...formData, platform: value })}
                  required
                >
                  <SelectTrigger className="admin-input">
                    <SelectValue placeholder="اختر المنصة" />
                  </SelectTrigger>
                  <SelectContent>
                    {platforms.map((platform) => (
                      <SelectItem key={platform.value} value={platform.value}>
                        {platform.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="request_product_name">اسم المنتج</Label>
                <Input
                  id="request_product_name"
                  required
                  value={formData.product_name}
                  onChange={(event) => setFormData({ ...formData, product_name: event.target.value })}
                  placeholder="مثال: كرسي مكتب مريح"
                  className="admin-input"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="request_product_url">رابط المنتج (اختياري)</Label>
                <Input
                  id="request_product_url"
                  type="url"
                  value={formData.product_url}
                  onChange={(event) => setFormData({ ...formData, product_url: event.target.value })}
                  placeholder="https://..."
                  className="admin-input"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="request_notes">ملاحظات إضافية (اختياري)</Label>
                <Textarea
                  id="request_notes"
                  value={formData.notes}
                  onChange={(event) => setFormData({ ...formData, notes: event.target.value })}
                  placeholder="أي تفاصيل إضافية حول الطلب"
                  className="admin-input min-h-24"
                />
              </div>

              <Button type="submit" className="w-full btn-primary" disabled={submitting}>
                {submitting ? 'جاري الإرسال...' : 'إرسال الطلب'}
              </Button>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
